import { defineMessages } from 'react-intl';

export default defineMessages({
    addDocumentTitle: {
        id: 'servicerequest.views.add-invoice.title.AddDocuments',
        defaultMessage: 'Add documents'
    },
    addDocumentSubtitle: {
        id: 'servicerequest.views.add-invoice.subtitle.AddDocuments',
        defaultMessage: 'Add new documents to this service request'
    },
    cancel: {
        id: 'servicerequest.views.add-document.buttons.Cancel_AX',
        defaultMessage: 'Cancel'
    },
    save: {
        id: 'servicerequest.views.add-documents.button.Save_AX',
        defaultMessage: 'Save'
    },
    selectDocumentTypeTitle: {
        id: 'ax.servicerequest.views.servicerequest.details.documentTypeRequiredTitle',
        defaultMessage: 'Document Type'
    },
    selectDocumentType: {
        id: 'ax.servicerequest.views.servicerequest.details.documentTypeRequired',
        defaultMessage: 'Required Document Type'
    }
});
